/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import * as React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { messages } from './messages';
import { ErrorNetworth } from 'constants/constants';
import { media } from 'styles/media';
import { useNetworth } from 'app/Provider/NetworthProvider';
import { useNavigate } from 'react-router-dom';
import { CirclePlus } from 'lucide-react';
import { AssetByType } from '../AssetByType/Loadable';
import { AssetByGoal } from '../AssetByGoal/Loadable';
import { Trackliabilities } from '../Trackliabilities/Loadable';
interface Props {}

export function TrackAssets(props: Props) {
  const { data: Data } = useNetworth();
  const [asset, setasset] = React.useState('Type');

  const navigate = useNavigate();
  const [selected, setSelected] = React.useState<'ASSETS' | 'LIABILITIES'>(
    'ASSETS',
  );

  const { t } = useTranslation();

  //function to render asset based on type
  const renderAssetComponent = () => {
    const DecideAndRender = () => {
      switch (asset) {
        case 'Type':
          return <AssetByType />;
        case 'Goals':
          return <AssetByGoal />;
        default:
          return null;
      }
    };
    return <>{DecideAndRender()}</>;
  };

  return (
    <Div className="border rounded-4 position-relative bg-white  ">
      {t('')}
      <div className="d-flex   justify-content-between px-3 align-items-center border-bottom">
        <div className="d-flex gap-3 align-items-center w-100">
          {selected === 'ASSETS' ? (
            <SubheadingPrimary className="my-1" style={{ width: '10%' }}>
              {t(messages.name())}
            </SubheadingPrimary>
          ) : (
            <SubheadingPrimary
              className="my-1"
              style={{ width: '10%' }}
            ></SubheadingPrimary>
          )}

          <div className="w-25">
            {selected === 'ASSETS' ? (
              <div className="d-flex align-items-center  gap-3">
                <AssetType
                  onClick={() => {
                    setasset('Goals');
                  }}
                  style={{ fontWeight: asset === 'Goals' ? '800' : 'normal' }}
                >
                  Goals
                </AssetType>
                <AssetType>Platforms</AssetType>
                <AssetType
                  onClick={() => {
                    setasset('Type');
                  }}
                  style={{ fontWeight: asset === 'Type' ? '800' : 'normal' }}
                >
                  Asset Type
                </AssetType>
              </div>
            ) : null}
          </div>
          <div className="d-flex align-items-center    gap-5 mx-5  w-25">
            <SelectText
              isSelected={selected === 'ASSETS'}
              fontWeight={400}
              onClick={() => setSelected('ASSETS')}
              className="py-3"
            >
              ASSETS
            </SelectText>
            <SelectText
              className="py-3"
              isSelected={selected === 'LIABILITIES'}
              fontWeight={400}
              onClick={() => setSelected('LIABILITIES')}
            >
              LIABILITIES
            </SelectText>
          </div>
        </div>

        <CirclePlus
          size={32}
          color="#FFFF"
          fill="#9089f7"
          strokeWidth={0.75}
          className="cursor-pointer"
          onClick={() => {
            navigate('/addasset');
          }}
        />
      </div>{' '}
      {!Data.total_networth ? (
        <div className="d-flex justify-content-between align-items-center p-3  ">
          <LoginBox className="d-flex justify-content-between   gap-xl-5 gap-4 align-items-center w-100  ">
            <LoginContainer className="d-flex  align-items-center gap-3 ">
              <img src={ErrorNetworth} alt="" className="img-fluid" />

              <div className="d-flex flex-column gap-3  ">
                <Box3text6>{t(messages.errorAccount())}</Box3text6>

                <Box3SubheadingSecondary className="w-75">
                  {t(messages.errorAsset())}
                </Box3SubheadingSecondary>
              </div>
            </LoginContainer>
            <CustomButton
              className=" d-flex align-items-center justify-content-center"
              onClick={() => navigate('/addasset')}
            >
              {selected === 'ASSETS' ? 'Add assets' : 'Add liabilities'}
            </CustomButton>
          </LoginBox>
        </div>
      ) : (
        <Container className="d-flex flex-column gap-xl-3 pt-4 px-3 h-100">
          {selected === 'ASSETS' ? (
            renderAssetComponent()
          ) : (
            <Trackliabilities />
          )}
        </Container>
      )}
    </Div>
  );
}

const Container = styled.div`
  overflow-y: auto;
  height: auto;
  padding-bottom: 100px;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #8276f4;

    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }
`;
const CustomButton = styled.div`
  width: 30vw;
  border-radius: 30px;
  height: 52px;
  background-color: #8276f4;
  color: #ffffff;
  cursor: pointer;
`;

const AssetType = styled.span`
  font-weight: 300;
  font-size: 16px;
  color: #af8eff;
  cursor: pointer;
`;

const SelectText = styled.h3<{ fontWeight?: number; isSelected?: boolean }>`
  font-size: 12px;
  font-weight: ${props => (props.isSelected ? 700 : props.fontWeight || 400)};
  color: ${props => (props.isSelected ? ' #22283A' : props.color || '#838EAE')};
  border-bottom: ${props => (props.isSelected ? '3px solid #22283A' : 'none')};

  cursor: pointer;
`;

const Div = styled.div`
  height: 55vh;

  overflow: hidden;
  ${media.medium} {
    width: 70vw;
  }
  ${media.small} {
    width: 90vw;
  }
`;

const SubheadingPrimary = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #22283a;
  ${media.medium} {
    font-size: 14px;
  }
`;

const LoginBox = styled.div`
  ${media.medium} {
    flex-direction: column;
    align-items: center;
    width: 100%;
    justify-content: center;
  }
  ${media.small} {
    flex-direction: column;
    align-items: center;
    width: 100%;
    justify-content: center;
  }
`;
const Box3text6 = styled.h3`
  font-size: 20px;
  font-weight: 500;
`;
const Box3SubheadingSecondary = styled.h3`
  font-size: 14px;
  font-weight: 400;
`;

const LoginContainer = styled.div`
  ${media.medium} {
    flex-direction: column;
  }
`;
